import { useTranslation } from 'react-i18next';

export const useDataTablePaginationOptions = () => {
    const { t } = useTranslation();
    
    return {
        rowsPerPageText: t('settingsPanel.dataTable.rowsPerPageText'),
        rangeSeparatorText: t('settingsPanel.dataTable.rangeSeparatorText'),
        selectAllRowsItem: true,
        selectAllRowsItemText: t('settingsPanel.dataTable.selectAllRowsItemText'),
    };
};
